import React from 'react';
import { SimplePaginationInfo } from '../../types';

interface PaginationProps {
  pagination: SimplePaginationInfo;
  totalItems: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ pagination, totalItems, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / pagination.limit);
  if (totalPages <= 1) return null;

  const { page } = pagination;
  const startPage = Math.max(1, page - 2);
  const endPage = Math.min(totalPages, page + 2);

  const baseBtnStyle: React.CSSProperties = {
    background: 'transparent',
    border: 'none',
    color: '#6E21A1',
    padding: '0 6px',
    fontSize: '11px',
    lineHeight: 1,
  };

  const pageBtnStyle: React.CSSProperties = {
    background: 'transparent',
    border: 'none',
    color: '#6E21A1',
    padding: '0 8px',
    fontSize: '14px',
  };

  return (
    <div className="d-flex justify-content-center pt-2 pb-1" style={{ background: '#e9e6ec' }}>
      <div
        className="d-flex align-items-center"
        style={{
          background: '#eee9f2',
          border: '1px solid #d6c9e1',
          padding: '7px 9px',
          color: '#6E21A1',
        }}
      >
        {/* Prev chevron */}
        <button
          type="button"
          style={baseBtnStyle}
          onClick={() => page > 1 && onPageChange(page - 1)}
          disabled={page === 1}
        >
          &lsaquo;
        </button>

        {/* Previous label */}
        <button
          type="button"
          style={{ ...pageBtnStyle, opacity: page === 1 ? 0.5 : 1 }}
          onClick={() => page > 1 && onPageChange(page - 1)}
          disabled={page === 1}
        >
          Previous
        </button>

        {/* first page if needed */}
        {startPage > 1 && (
          <button type="button" style={pageBtnStyle} onClick={() => onPageChange(1)}>1</button>
        )}
        {startPage > 2 && (
          <span style={{ ...pageBtnStyle, cursor: 'default' }}>…</span>
        )}

        {/* windowed pages */}
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((p) => (
          <button
            key={p}
            type="button"
            style={{
              ...pageBtnStyle,
              fontWeight: p === page ? 700 : 400,
            }}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}

        {/* trailing pages */}
        {endPage < totalPages - 1 && (
          <span style={{ ...pageBtnStyle, cursor: 'default' }}>…</span>
        )}
        {endPage < totalPages && (
          <button type="button" style={pageBtnStyle} onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </button>
        )}

        {/* Next label */}
        <button
          type="button"
          style={{ ...pageBtnStyle, opacity: page === totalPages ? 0.5 : 1 }}
          onClick={() => page < totalPages && onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          Next
        </button>

        {/* Next chevron */}
        <button
          type="button"
          style={baseBtnStyle}
          onClick={() => page < totalPages && onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          &rsaquo;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
